<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONVÊNIOS</span>
                </h4>
                <app-tabela
                    :itens="convenios"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false">
                    <template slot="nuValorConvenio" slot-scope="data">
                        <span class="text-nowrap">{{data.nuValorConvenio | currency}}</span>
                    </template>
                    <template slot="vigencia" slot-scope="data">
                        {{data.dtInicioVigencia ? $moment(data.dtInicioVigencia).format('DD/MM/YYYY') : ''}}
                        <span v-if="data.dtInicioVigencia">a</span>
                        {{data.dtFimVigencia ? $moment(data.dtFimVigencia).format('DD/MM/YYYY') : ''}}
                    </template>
                    <template slot="situacaoConvenio" slot-scope="data">
                        <app-status
                            :status="data.situacaoConvenio.toUpperCase()"
                        ></app-status>
                    </template>

                    <template slot="descricaoStatusRM" slot-scope="data">
                        <b-badge variant="primary" class="ml-2">
                            {{data.descricaoStatusRM}}
                        </b-badge>
                    </template>

                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary mr-1">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="Detalhes(data.idConvenio)"
                                v-if="temAcessoDetalhar"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    props: {
        ConveniosServicos: {
            type: Object,
            default: () => ({}) 
        },
        rotaDetalhar: {
            type: String
        },

        rotaListagem: {
            type: String
        },
        temAcessoDetalhar: {
            type: Boolean,
            default: () => false
        },
    },

    data() {
        return {
            convenios: [],
            campos: [
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Convênio',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'convenente',
                    label: 'Convenente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcObjeto',
                    label: 'Objeto',
                    filterable: true,
                    tdClass: 'colObjeto'
                },
                {
                    key: 'vigencia',
                    label: 'Vigência'
                },
                {
                    key: 'nuValorConvenio',
                    label: 'Total',
                    tdClass: 'text-right'
                },
                {
                    key: 'situacaoConvenio',
                    label: 'Situação',
                    filterable: true
                },
                {
                    key: 'descricaoStatusRM',
                    label: 'RM',
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        ListarConvenios() {
            this.$store.dispatch('addRequest')
            this.ConveniosServicos.ListarConvenios().then(response => {
                if (response) {
                    if (response.success) {
                        this.convenios = response.data;
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        Detalhes(id){
            this.$router.push({
                name: this.rotaDetalhar,
                params: {
                    idConvenio: id
                }
            })
        }
    },

    created() {
        this.ListarConvenios()
    },
}
</script>

